import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';
import ReactAudioPlayer from 'react-audio-player';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import SubmissionDetailContent from "composer/views/retriever/SubmissionDetailContent.jsx"

import {
  Icon,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
} from '@material-ui/core';

class SubmissionDetailAnswer extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      answerData: this.props.answerData,
    };
    autoBind(this);
  }

  handleCompareAnswerClicked() {
    this.props.parent.props.parent.refs.compareAnswerDialog.setState({
      open: true,
    })
    this.props.parent.props.parent.getAllAnswers(this.state.answerData);
  }

  handleStatisticsClicked() {
    this.props.parent.props.parent.refs.statisticsDialog.setState({
      open: true,
    });
    this.props.parent.props.parent.getAllAnswers(this.state.answerData);
  }

  render() {
    return (
      <div>
        <Switch condition={this.state.answerData.kind}>
          <Case value={"2"}>
            <ListItem>
              <ListItemIcon>
                <Icon style={{fontSize:'36px'}}>list</Icon>
              </ListItemIcon>
              <ListItemText
                primary={this.state.answerData.content}
                secondary={Localization.strings.SUBMITTED + " " + this.state.answerData.update_time}
              />
              <ListItemSecondaryAction>
                <Tooltip title={Localization.strings.SHOW_STATISTICS}>
                  <IconButton onClick={this.handleStatisticsClicked}>
                    <Icon>insert_chart</Icon>
                  </IconButton>
                </Tooltip>
                <Tooltip title={Localization.strings.COMPARE_ANSWERS}>
                  <IconButton onClick={this.handleCompareAnswerClicked}>
                    <Icon>group</Icon>
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon><Icon></Icon></ListItemIcon>
              <SubmissionDetailContent root={this.props.root} parent={this} answerData={this.state.answerData}/>
            </ListItem>
          </Case>
          <Case value={"4"}>
            <ListItem>
              <ListItemIcon>
                <Icon>mic</Icon>
              </ListItemIcon>
              <ListItemText
                primary={this.state.answerData.content}
                secondary={Localization.strings.SUBMITTED + " " + this.state.answerData.update_time}
              />
              <ListItemSecondaryAction>
                <Tooltip title={Localization.strings.COMPARE_ANSWERS}>
                  <IconButton onClick={this.handleCompareAnswerClicked}>
                    <Icon>group</Icon>
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
              <ListItemIcon><Icon></Icon></ListItemIcon>
              <SubmissionDetailContent root={this.props.root} parent={this} answerData={this.state.answerData}/>
            </ListItem>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default SubmissionDetailAnswer;
